"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.universalProperties = exports["default"] = void 0;
var formProperties = {
  label: {
    type: 'string',
    description: 'Name of form',
    isRequired: true,
    acceptedValues: null
  },
  form_content: {
    type: 'object',
    description: 'Contents of form',
    isRequired: true,
    acceptedValues: null
  }
};
var calendlyEventProperties = {
  page: {
    type: 'string',
    description: 'The page the Calendly link is on',
    isRequired: true,
    acceptedValues: null
  },
  section: {
    type: 'string',
    description: 'The html section of the page the Calendly link is located on',
    isRequired: true,
    acceptedValues: new Set(['header', 'topbar', 'sidebar', 'article', 'footer', 'toc'])
  },
  text: {
    type: 'string',
    description: 'The text the user sees the Calendly link as',
    isRequired: true,
    acceptedValues: null
  }
};
var commandAiProperties = {
  eventName: {
    type: 'string',
    description: 'Name of CommandAI event',
    isRequired: true,
    acceptedValues: null
  },
  eventProperties: {
    type: 'object',
    description: 'Properties of CommandAI event',
    isRequired: false,
    acceptedValues: null
  }
};
var events = {
  linkClicked: {
    id: 'linkClicked',
    eventName: 'Link Clicked',
    eventDescription: 'Links are anything on the page with an href. Links should take you to another `place` when clicked: for example, a new page, a new section of a page, etc.',
    properties: {
      section: {
        type: 'string',
        description: 'The html section of the page the link is located on',
        isRequired: true,
        acceptedValues: new Set(['header', 'topbar', 'sidebar', 'article', 'footer', 'toc'])
      },
      style: {
        type: 'string',
        description: 'The type of the link in terms of its styling',
        isRequired: true,
        acceptedValues: new Set(['cta primary', 'cta secondary', 'arrow', 'unstyled', 'inline', 'image', 'dropdown', 'modal', 'card'])
      },
      label: {
        type: 'string',
        description: 'A reserved attribute targeting a specific link',
        isRequired: false,
        acceptedValues: null
      },
      text: {
        type: 'string',
        description: 'The text the user sees the link as',
        isRequired: true,
        acceptedValues: null
      },
      path: {
        type: 'string',
        description: 'The href the link points to',
        isRequired: true,
        acceptedValues: null
      }
    }
  },
  drawerOpened: {
    id: 'drawerOpened',
    eventName: 'Drawer Opened',
    eventDescription: 'Tracked when a drawer opens',
    properties: {
      label: {
        type: 'string',
        description: 'Type of drawer',
        isRequired: true,
        acceptedValues: new Set(['mobile nav'])
      }
    }
  },
  drawerClosed: {
    id: 'drawerClosed',
    eventName: 'Drawer Closed',
    eventDescription: 'Should only be tracked when a user intentionally closes a drawer ',
    properties: {
      label: {
        type: 'string',
        description: 'Type of drawer',
        isRequired: true,
        acceptedValues: new Set(['mobile nav'])
      }
    }
  },
  dropdownOpened: {
    id: 'dropdownOpened',
    eventName: 'Dropdown Opened',
    eventDescription: 'Tracked when a dropdown opens',
    properties: {
      label: {
        type: 'string',
        description: 'Type of dropdown',
        isRequired: true,
        acceptedValues: new Set(['app selector', 'org selector', 'account menu', 'form', 'action creator', 'topbar', 'sidebar'])
      },
      text: {
        type: 'string',
        description: 'Text in the opened dropdown button',
        isRequired: true,
        acceptedValues: null
      }
    }
  },
  dropdownClosed: {
    id: 'dropdownClosed',
    eventName: 'Dropdown Closed',
    eventDescription: 'Should only be tracked when a user intentionally closes a dropdown ',
    properties: {
      label: {
        type: 'string',
        description: 'Type of dropdown',
        isRequired: true,
        acceptedValues: new Set(['app selector', 'org selector', 'account menu', 'select', 'form', 'action creator', 'topbar', 'sidebar'])
      },
      text: {
        type: 'string',
        description: 'Text in the closed dropdown button',
        isRequired: true,
        acceptedValues: null
      }
    }
  },
  formFailed: {
    id: 'formFailed',
    eventName: 'Form Failed',
    eventDescription: 'Tracked when a user fills out a form and it fails validation upon submission',
    properties: {
      label: {
        type: 'string',
        description: 'Name of form',
        isRequired: true,
        acceptedValues: null
      },
      form_content: {
        type: 'object',
        description: 'Contents of form',
        isRequired: true,
        acceptedValues: null
      }
    }
  },
  formSubmitted: {
    id: 'formSubmitted',
    eventName: 'Form Submitted',
    eventDescription: 'Tracked when a user fills out a form and the submission is successful',
    properties: formProperties
  },
  insuranceWhitepaperFormSubmitted: {
    id: 'insuranceWhitepaperFormSubmitted',
    eventName: 'Insurance White Paper Form Submitted',
    eventDescription: 'Tracked when a user fills out the Auto Insurance whitepaper form and the submission is successful',
    properties: formProperties
  },
  fleetWhitepaperFormSubmitted: {
    id: 'fleetWhitepaperFormSubmitted',
    eventName: 'Fleet White Paper Form Submitted',
    eventDescription: 'Tracked when a user fills out the Fleet Management whitepaper form and the submission is successful',
    properties: formProperties
  },
  carSharingWhitepaperFormSubmitted: {
    id: 'carSharingWhitepaperFormSubmitted',
    eventName: 'Car Sharing White Paper Form Submitted',
    eventDescription: 'Tracked when a user fills out the Car Sharing whitepaper form and the submission is successful',
    properties: formProperties
  },
  evChargingWhitepaperFormSubmitted: {
    id: 'evChargingWhitepaperFormSubmitted',
    eventName: 'EV Charging White Paper Form Submitted',
    eventDescription: 'Tracked when a user fills out the EV Charging whitepaper form and the submission is successful',
    properties: formProperties
  },
  buildVsBuyFormSubmitted: {
    id: 'buildVsBuyFormSubmitted',
    eventName: 'Build vs Buy Form Submitted',
    eventDescription: 'Tracked when a user fills out the Build vs Buy Guide form and the submission is successful',
    properties: formProperties
  },
  roadUsageChargeFormSubmitted: {
    id: 'roadUsageChargeFormSubmitted',
    eventName: 'Road Usage Charge Form Submitted',
    eventDescription: 'Tracked when a user fills out the Road Usage Charge Guide form and the submission is successful',
    properties: formProperties
  },
  repairAndMaintenanceFormSubmitted: {
    id: 'repairAndMaintenanceFormSubmitted',
    eventName: 'Repair And Maintenance Form Submitted',
    eventDescription: 'Tracked when a user fills out the Repair and Maintenance Guide form and the submission is successful',
    properties: formProperties
  },
  utilitiesFormSubmitted: {
    id: 'utilitiesFormSubmitted',
    eventName: 'Utilities Form Submitted',
    eventDescription: 'Tracked when a user fills out the Utilities Guide form and the submission is successful',
    properties: formProperties
  },
  demoFormSubmitted: {
    id: 'demoFormSubmitted',
    eventName: 'Demo Form Submitted',
    eventDescription: 'Tracked when a user fills out the demo request form and the submission is successful',
    properties: formProperties
  },
  contactFormSubmitted: {
    id: 'contactFormSubmitted',
    eventName: 'Contact Form Submitted',
    eventDescription: 'Tracked when a user fills out the contact form and the submission is successful',
    properties: formProperties
  },
  mailingListFormSubmitted: {
    id: 'mailingListFormSubmitted',
    eventName: 'Mailing List Form Submitted',
    eventDescription: 'Tracked when a user fills out the mailing list signup form and the submission is successful',
    properties: formProperties
  },
  developerSignup: {
    id: 'developerSignup',
    eventName: 'Developer Signup',
    eventDescription: 'Tracked when a user fills out the developer signup form and the submission is successful',
    properties: formProperties
  },
  tabSelected: {
    id: 'tabSelected',
    eventName: 'Tab Selected',
    eventDescription: 'Tabs are used to change the view in a localized area of a greater page to display different information regarding a common topic (ex: different languages in a code block)',
    properties: {
      label: {
        type: 'string',
        description: 'Combination of the component the tab is in with the type of the tab they are switching',
        isRequired: true,
        acceptedValues: null
      },
      text: {
        type: 'string',
        description: 'Text user sees on the tab',
        isRequired: true,
        acceptedValues: null
      }
    }
  },
  buttonClicked: {
    id: 'buttonClicked',
    eventName: 'Button Clicked',
    eventDescription: 'A button click triggers an action while keeping you on the same page and has limited effect of the view (ex: the copy button on a code block)',
    properties: {
      label: {
        type: 'string',
        description: 'Action performed by clicking the button',
        isRequired: true,
        acceptedValues: new Set(['copy', 'download', 'reveal', 'chat', 'back', 'forward', 'filter', 'backend action', 'connect action', 'action', 'reset', 'open menu', 'close menu'])
      },
      text: {
        type: 'string',
        description: 'Text on the button user sees for backend actions, text that is copied for copy, and description of download for download',
        isRequired: true,
        acceptedValues: null
      }
    }
  },
  modalOpened: {
    id: 'modalOpened',
    eventName: 'Modal Opened',
    eventDescription: 'Tracked when a modal is opened',
    properties: {
      label: {
        type: 'string',
        description: 'Action performed by the modal',
        isRequired: true,
        acceptedValues: null
      },
      title: {
        type: 'string',
        description: 'Text that the user sees at top of modal',
        isRequired: true,
        acceptedValues: null
      }
    }
  },
  modalClosed: {
    id: 'modalClosed',
    eventName: 'Modal Closed',
    eventDescription: 'Tracked when a modal is closed',
    properties: {
      label: {
        type: 'string',
        description: 'Action performed by the modal',
        isRequired: true,
        acceptedValues: null
      },
      title: {
        type: 'string',
        description: 'Text that the user sees at top of modal',
        isRequired: true,
        acceptedValues: null
      }
    }
  },
  tooltipOpened: {
    id: 'tooltipOpened',
    eventName: 'Tooltip Opened',
    eventDescription: 'Tracked when a tooltip is opened',
    properties: {
      label: {
        type: 'string',
        description: 'What element tooltip is attached to',
        isRequired: true,
        acceptedValues: null
      },
      text: {
        type: 'string',
        description: 'Text of the tooltip',
        isRequired: true,
        acceptedValues: null
      }
    }
  },
  searchBarQueried: {
    id: 'searchBarQueried',
    eventName: 'Search Bar Queried',
    eventDescription: 'Tracks queries user makes in a search bar',
    properties: {
      label: {
        type: 'string',
        description: 'What page the search bar is in',
        isRequired: true,
        acceptedValues: null
      },
      value: {
        type: 'string',
        description: 'What the user has entered in the search bar',
        isRequired: true,
        acceptedValues: null
      }
    }
  },
  requestDemoButtonClicked: {
    id: 'requestDemoButtonClicked',
    eventName: 'Request a demo button clicked',
    eventDescription: 'Tracked when a user clicks on the request a demo button',
    properties: {
      page: {
        type: 'string',
        description: 'The page the Request a Demo button is on',
        isRequired: true,
        acceptedValues: null
      },
      section: {
        type: 'string',
        description: 'The html section of the page the Request a Demo button is located on',
        isRequired: true,
        acceptedValues: new Set(['header', 'topbar', 'sidebar', 'article', 'footer', 'toc'])
      },
      text: {
        type: 'string',
        description: 'The text the user sees the Request a Demo button as',
        isRequired: true,
        acceptedValues: null
      }
    }
  },
  calendlyDemoModalOpened: {
    id: 'calendlyDemoModalOpened',
    eventName: 'Calendly Demo Modal Opened',
    eventDescription: 'Tracked when a user clicks on a CTA that opens the Calendly modal for demo request bookings',
    properties: calendlyEventProperties
  },
  calendlyDemoProfilePageViewed: {
    id: 'calendlyDemoProfilePageViewed',
    eventName: 'Calendly Demo Profile Page Viewed',
    eventDescription: 'Tracked when a user clicks on a CTA that opens the Calendly modal for demo request bookings',
    properties: calendlyEventProperties
  },
  calendlyDemoEventTypeViewed: {
    id: 'calendlyDemoEventTypeViewed',
    eventName: 'Calendly Demo Event Type Viewed',
    eventDescription: 'Tracked when a user completes the first form and moves on to view the booking calendar',
    properties: calendlyEventProperties
  },
  calendlyDemoTimeSelected: {
    id: 'calendlyDemoTimeSelected',
    eventName: 'Calendly Demo Time Selected',
    eventDescription: 'Tracked when a user confirms a date and time through the Calendly form, but before they submit',
    properties: calendlyEventProperties
  },
  calendlyDemoRequestSubmitted: {
    id: 'calendlyDemoRequestSubmitted',
    eventName: 'Calendly Demo Request Submitted',
    eventDescription: 'Tracked when a user completes the Calendly form and submits a request for a demo',
    properties: calendlyEventProperties
  },
  applicationLoaded: {
    id: 'applicationLoaded',
    eventName: 'Application Loaded',
    eventDescription: 'Tracked when a user loads an application on the dashboard',
    properties: {
      applicationId: {
        type: 'string',
        description: 'Application ID of the application they are using',
        isRequired: true,
        acceptedValues: null
      }
    }
  },
  applicationActive: {
    id: 'applicationActive',
    eventName: 'Application Active Time',
    eventDescription: 'Length of time in ms the user was actively using the dashboard',
    properties: {
      msActive: {
        type: 'number',
        description: 'Number of ms that the user was active in the dashboard',
        isRequired: true,
        acceptedValues: null
      },
      applicationId: {
        type: 'string',
        description: 'Application ID of the application they are active on',
        isRequired: true,
        acceptedValues: null
      }
    }
  },
  commandAi: {
    id: 'commandAi',
    eventName: 'commandAi',
    properties: commandAiProperties
  }
};
var universalProperties = {
  page: {
    type: 'string',
    description: 'Used for oem-auth where page names need to be specified on track calls',
    isRequired: false,
    acceptedValues: null
  }
};
exports.universalProperties = universalProperties;
var _default = events;
exports["default"] = _default;